import { render, staticRenderFns } from "./GlobalPositionTemplate.vue?vue&type=template&id=0afa939c&scoped=true&"
import script from "./GlobalPositionTemplate.vue?vue&type=script&lang=js&"
export * from "./GlobalPositionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPositionTemplate.vue?vue&type=style&index=0&id=0afa939c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa939c",
  null
  
)

export default component.exports